module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5n1n2r-910300e25370e2bf32a932d4e23acbe3.svg";